<script>
	import { Router, Link, Route } from "svelte-routing";
	import { onMount } from 'svelte';

	import Start from "./start.svelte";
	import Instructions from "./instructions.svelte"
	import Instructions2 from "./instruction2.svelte"
	import Result from "./result.svelte"
	import Review from "./review.svelte"
	import Reattempt from "./reattempt.svelte"


	function handleOfflineEvent() {
		showError()
	}

    function handleOnlineEvent() {
		showError(false)
    }

	const showError = (show=true) => {
		let el = document.querySelector("#error-modal-container .holder")
		try {
			if(show){
				el.style.bottom = "8px"
			} else {
				el.style.bottom = "-200px"
			}
		} catch (error) {
			
		}
	}

	onMount(async () => {
		window.addEventListener('offline', handleOfflineEvent);
    	window.addEventListener('online', handleOnlineEvent);
	});
</script>
<div id="error-modal-container">
	<div class="holder">
		<div class="body">
			<h3>No internet!</h3>
			<p>Please ensure that you have a stable internet connection; otherwise, you may encounter issues submitting the exam and responses may not be saved</p>
			<button on:click={()=>showError(false)} class="close-btn">
				<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"/></svg>
			</button>
		</div>
	</div>
</div>
<Router>
	<Route path="/" let:params>
		<Start />
	</Route>



	<Route path="/start/:token" let:params>
		<Instructions token="{params.token}"></Instructions>
	</Route> 



	
	<Route path="/instructions/:token" let:params>
		<Instructions2 token="{params.token}"></Instructions2>
	</Route>
	<Route path="/questions/:token/:currentQuestionNo/:currentSectionNo" let:params>
		<Start token="{params.token}" currentQuestionNo={params.currentQuestionNo} currentSectionNo={params.currentSectionNo} />
	</Route>
	<Route path="/result/:doneTestId" let:params>
		<Result doneTestId="{params.doneTestId}"/>
	</Route>
	<Route path="/review/:doneTestId/:rank/:currentQuestionNo/:currentSectionNo" let:params>
		<Review doneTestId="{params.doneTestId}"  rank={params.rank} currentQuestionNo={params.currentQuestionNo} currentSectionNo={params.currentSectionNo}/>
	</Route>
	<Route path="/reattempt/:doneTestId/:currentQuestionNo/:currentSectionNo" let:params>
		<Reattempt doneTestId="{params.doneTestId}" currentQuestionNo={params.currentQuestionNo} currentSectionNo={params.currentSectionNo}/>
	</Route>
</Router>